import { useState, useEffect } from 'react';
import { getAppSetting } from '../lib/supabase';

const FEATURES = [
  {
    n: '01',
    title: 'Organizza la serata',
    desc: 'Crea l\'evento in un minuto: titolo, data, location. Scegli se tenerla aperta a tutti, solo su invito, o con approvazione. Monitora le adesioni e l\'attrezzatura portata da ciascuno.',
  },
  {
    n: '02',
    title: 'Scegliete insieme i brani da suonare',
    desc: 'Ogni musicista propone brani e si iscrive con il suo strumento e tonalità. Vedi subito chi suona cosa, chi manca, e qual è la copertura strumentale della serata.',
  },
  {
    n: '03',
    title: 'Gestisci il live',
    desc: 'Durante la serata scegli il prossimo brano in base ai like del pubblico o a una rotazione equa tra i musicisti. Segna i brani suonati in tempo reale.',
  },
  {
    n: '04',
    title: 'Coinvolgi il pubblico',
    desc: 'Un QR code porta gli ospiti sulla pagina live: vedono la scaletta aggiornata in tempo reale e votano i brani che vogliono sentire.',
  },
];

const NAV_STYLE = {
  position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
  background: 'rgba(0,0,0,0.55)',
  backdropFilter: 'blur(16px)',
  borderBottom: '1px solid rgba(237,77,29,0.06)',
  padding: '0 20px',
  paddingTop: 'env(safe-area-inset-top)',
  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  height: 'calc(80px + env(safe-area-inset-top))',
  boxSizing: 'border-box',
};

const BTN_BASE = {
  width: 130, padding: '10px 0', borderRadius: 10,
  fontSize: 17, fontWeight: 700, cursor: 'pointer',
  fontFamily: "'Exo 2', sans-serif",
  textAlign: 'center',
};

function DesktopHome({ bg, onRegister, onLogin }) {
  return (
    <div style={{ minHeight: '100vh', background: '#181614', color: '#E8DDD0', fontFamily: "'Exo 2', sans-serif" }}>

      {/* Navbar — identica all'header dell'app */}
      <nav style={NAV_STYLE}>
        <img src="/logo.png" alt="Jammo" style={{ height: 75, objectFit: 'contain' }}/>
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={onLogin} style={{
            ...BTN_BASE,
            background: 'rgba(255,255,255,0.07)',
            border: '1.5px solid rgba(255,255,255,0.15)',
            color: 'rgba(255,255,255,0.6)',
          }}>Accedi</button>
          <button onClick={onRegister} style={{
            ...BTN_BASE,
            background: '#ED4D1D',
            border: 'none',
            color: '#fff',
            boxShadow: '0 2px 16px rgba(237,77,29,0.4)',
          }}>Registrati</button>
        </div>
      </nav>

      {/* Hero */}
      <div style={{ position: 'relative', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {bg && (
          <div style={{
            position: 'absolute', inset: 0,
            backgroundImage: `url(${bg})`,
            backgroundSize: 'cover', backgroundPosition: 'center',
          }}/>
        )}
        <div style={{
          position: 'absolute', inset: 0,
          background: bg
            ? 'linear-gradient(to bottom, rgba(13,11,9,0.55) 0%, rgba(13,11,9,0.75) 50%, rgba(24,22,20,1) 100%)'
            : '#181614',
        }}/>
        <div style={{ position: 'relative', zIndex: 2, textAlign: 'center', maxWidth: 720, padding: '0 32px' }}>
          <div style={{ fontSize: 56, fontWeight: 900, lineHeight: 1.1, marginBottom: 20, letterSpacing: '-1px' }}>
            Organizza serate musicali<br/>
            <span style={{ color: '#ED4D1D' }}>tra amici musicisti.</span>
          </div>
          <div style={{ fontSize: 22, color: 'rgba(255,255,255,0.55)', marginBottom: 40, lineHeight: 1.5 }}>
            Scalette, brani, gestione del live — tutto in un posto.<br/>Gratis, senza complicazioni.
          </div>
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', marginBottom: 20 }}>
            <button onClick={onRegister} style={{
              width: 220, padding: '18px 0', borderRadius: 14, fontSize: 20, fontWeight: 800, cursor: 'pointer',
              background: '#ED4D1D', border: 'none', color: '#fff',
              fontFamily: "'Exo 2', sans-serif",
              boxShadow: '0 4px 32px rgba(237,77,29,0.5)',
            }}>Registrati — è gratis</button>
            <button onClick={onLogin} style={{
              width: 220, padding: '18px 0', borderRadius: 14, fontSize: 20, fontWeight: 600, cursor: 'pointer',
              background: 'rgba(255,255,255,0.08)', border: '1.5px solid rgba(255,255,255,0.18)', color: 'rgba(255,255,255,0.7)',
              fontFamily: "'Exo 2', sans-serif",
            }}>Ho già un account</button>
          </div>
          <div style={{ marginBottom:24 }}>
            <span style={{ fontSize:16, color:'#f5c842', fontWeight:600 }}>Servizio non attivo — in fase di test</span>
          </div>
          <a href="#come-funziona" onClick={e => { e.preventDefault(); document.getElementById('come-funziona').scrollIntoView({ behavior: 'smooth' }); }} style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12,
            textDecoration: 'none', color: 'rgba(255,255,255,0.6)',
            marginTop: 24,
          }}>
            <span style={{ fontSize: 18, fontWeight: 600, letterSpacing: '0.04em' }}>Scopri come funziona</span>
            <svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <polygon points="11,14 0,0 22,0" fill="rgba(255,255,255,0.55)"/>
            </svg>
          </a>
        </div>
      </div>

      {/* Come funziona */}
      <div id="come-funziona" style={{ padding: '96px 48px', background: '#181614' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <div style={{ fontSize: 16, fontWeight: 700, color: '#ED4D1D', letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: 12 }}>
            Come funziona
          </div>
          <div style={{ fontSize: 38, fontWeight: 900, marginBottom: 56, lineHeight: 1.15 }}>
            Dalla prima idea<br/>all'ultima nota.
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 24 }}>
            {FEATURES.map(f => (
              <div key={f.n} style={{
                background: '#1F1C18', borderRadius: 20, padding: '36px 40px',
                border: '1px solid rgba(255,255,255,0.06)',
              }}>
                <div style={{ fontSize: 16, fontWeight: 800, color: '#ED4D1D', letterSpacing: '0.1em', marginBottom: 14 }}>{f.n}</div>
                <div style={{ fontSize: 24, fontWeight: 800, marginBottom: 10 }}>{f.title}</div>
                <div style={{ fontSize: 18, color: 'rgba(255,255,255,0.5)', lineHeight: 1.6 }}>{f.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA finale */}
      <div style={{ padding: '96px 48px', background: '#1F1C18', textAlign: 'center' }}>
        <div style={{ maxWidth: 600, margin: '0 auto' }}>
          <div style={{ fontSize: 40, fontWeight: 900, marginBottom: 16, lineHeight: 1.15 }}>
            Pronto a suonare?
          </div>
          <div style={{ fontSize: 19, color: 'rgba(255,255,255,0.45)', marginBottom: 36 }}>
            Unisciti ai musicisti che usano Jammo per organizzare le loro serate.
          </div>
          <button onClick={onRegister} style={{
            padding: '18px 48px', borderRadius: 14, fontSize: 20, fontWeight: 800, cursor: 'pointer',
            background: '#ED4D1D', border: 'none', color: '#fff',
            fontFamily: "'Exo 2', sans-serif",
            boxShadow: '0 4px 32px rgba(237,77,29,0.45)',
          }}>Registrati — è gratis</button>
          <div style={{ marginTop: 20, fontSize: 16, color: 'rgba(255,255,255,0.2)' }}>
            Jammo è in fase di test — gratuita e in continua evoluzione
          </div>
        </div>
      </div>

      {/* Footer */}
      <div style={{
        padding: '28px 20px',
        background: '#181614',
        borderTop: '1px solid rgba(255,255,255,0.06)',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        fontSize: 16, color: 'rgba(255,255,255,0.25)',
      }}>
        <span>Jammo © 2026</span>
        <span>Paolo Murri · Roma</span>
      </div>
    </div>
  );
}

function MobileLanding({ bg, onRegister, onLogin }) {
  return (
    <div style={{
      minHeight: '100vh',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 'max(env(safe-area-inset-top),40px) 24px max(env(safe-area-inset-bottom),40px)',
      overflow: 'hidden',
    }}>
      {bg && (
        <div style={{
          position: 'absolute', inset: 0,
          backgroundImage: `url(${bg})`,
          backgroundSize: 'cover', backgroundPosition: 'center',
          zIndex: 0,
        }}/>
      )}
      <div style={{
        position: 'absolute', inset: 0,
        background: bg
          ? 'linear-gradient(to bottom, rgba(13,11,9,0.72) 0%, rgba(13,11,9,0.88) 60%, rgba(13,11,9,0.97) 100%)'
          : '#0D0B09',
        zIndex: 1,
      }}/>
      <div style={{ position: 'relative', zIndex: 2, width: '100%', maxWidth: 400, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <img src="/logo.png" alt="Jammo" style={{ height: 80, objectFit: 'contain', marginBottom: 32 }}/>
        <div style={{ fontSize: 30, fontWeight: 900, color: '#E8DDD0', textAlign: 'center', lineHeight: 1.15, marginBottom: 8 }}>
          Benvenuto su Jammo
        </div>
        <div style={{ fontSize: 17, color: 'rgba(255,255,255,0.5)', textAlign: 'center', marginBottom: 12 }}>
          L'app per organizzare serate musicali tra amici
        </div>
        <div style={{ marginBottom: 20 }}>
          <span style={{ fontSize:16, color:'#f5c842', fontWeight:600 }}>Servizio non attivo — in fase di test</span>
        </div>
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 36 }}>
          {[
            'Scegli o crea una serata',
            'Invita altri amici musicisti',
            'Condividi idee e brani da suonare',
            'Gestisci il live in modo semplice e divertente',
          ].map(item => (
            <div key={item} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#ED4D1D', flexShrink: 0 }}/>
              <span style={{ fontSize: 17, color: 'rgba(255,255,255,0.65)', lineHeight: 1.4 }}>{item}</span>
            </div>
          ))}
        </div>
        <button onClick={onRegister} style={{
          width: '100%', padding: '16px', borderRadius: 14, border: 'none',
          background: '#ED4D1D', color: '#fff', fontSize: 19, fontWeight: 800,
          cursor: 'pointer', marginBottom: 12, fontFamily: "'Exo 2', sans-serif",
          boxShadow: '0 4px 24px rgba(237,77,29,0.45)',
        }}>
          Registrati — è gratis
        </button>
        <button onClick={onLogin} style={{
          width: '100%', padding: '14px', borderRadius: 14,
          background: 'rgba(255,255,255,0.07)',
          border: '1.5px solid rgba(255,255,255,0.15)',
          color: 'rgba(255,255,255,0.6)', fontSize: 17, fontWeight: 600,
          cursor: 'pointer', fontFamily: "'Exo 2', sans-serif",
        }}>
          Ho già un account — Accedi
        </button>
      </div>
    </div>
  );
}

function LandingPage({ onRegister, onLogin }) {
  const [bg, setBg] = useState(null);
  const [isDesktop, setIsDesktop] = useState(() => window.innerWidth >= 768);

  useEffect(() => {
    getAppSetting('default_venue_bg').then(url => { if (url) setBg(url); }).catch(() => {});
    const handleResize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (isDesktop) return <DesktopHome bg={bg} onRegister={onRegister} onLogin={onLogin}/>;
  return <MobileLanding bg={bg} onRegister={onRegister} onLogin={onLogin}/>;
}

export default LandingPage;
